import { DashboardFigure } from "@components/Dashboards/shell";

import { useClientEmployeeLastUsedTimeStatQuery } from "./EmployeeUsageTimeStat.g";

type Props = {
  clientEmployeeId: string;
  clientId: string;
  applicationResourceId?: string;
  prominent?: boolean;
};

export const EmployeeUsageTimeStat = ({
  clientEmployeeId,
  clientId,
  applicationResourceId,
  prominent,
}: Props) => {
  const { data, isLoading } = useClientEmployeeLastUsedTimeStatQuery({
    employeeId: clientEmployeeId,
    clientId,
    ...(applicationResourceId && { applicationResourceId }),
  });

  const sessionDurationAggregate =
    data?.employeeSessions?.aggregate?.max?.updatedAt;

  const formatTimeAgo = (isoDate: string | null | undefined): string => {
    if (!isoDate) return "Never";
    const lastUsed = new Date(isoDate);
    const now = new Date();
    const diffMs = now.getTime() - lastUsed.getTime();

    if (diffMs < 0) return "In the future";

    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays > 0) {
      return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
    }
    return "Today";
  };

  const formattedDuration = formatTimeAgo(sessionDurationAggregate);

  return (
    <DashboardFigure
      prominent={prominent}
      stacked
      label="Last activity"
      value={formattedDuration}
      isLoading={isLoading}
    />
  );
};
